/** Small formatters for the submissions pages. */

export const duration = (seconds) => {
  if (seconds === null || seconds === undefined) return "—";
  const s = Math.round(seconds);
  if (s < 60) return `${s}s`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ${m % 60 ? `${m % 60}m` : ""}`.trim();
  const d = Math.floor(h / 24);
  return `${d}d ${h % 24 ? `${h % 24}h` : ""}`.trim();
};

export const ago = (iso, now = Date.now()) => {
  if (!iso) return "—";
  const seconds = Math.max(0, (now - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return "just now";
  return `${duration(seconds).split(" ")[0]} ago`;
};

export const date = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" }) : "—";

export const percent = (value) => (value === null || value === undefined ? "—" : `${Math.round(value)}%`);

export const number = (value, digits = 1) =>
  value === null || value === undefined ? "—" : `${Number(value.toFixed(digits))}`;

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

export const fileSize = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
